<div class="w-full mx-auto p-5 space-y-5">

  <!-- ============================================================ -->
  <!-- Header consolidado                                            -->
  <!-- ============================================================ -->
  <div class="flex flex-wrap items-end justify-between gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Inscripciones</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">{{ view === 'individual' ? 'Individuales' : 'Empresariales' }}</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">
        {{ view === 'individual' ? 'Inscripciones Individuales' : 'Inscripciones Empresariales' }}
      </h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ totalRecords }} {{ view === 'individual' ? 'participantes' : 'empresas' }} ·
        Seguimiento de inscripciones en proyectos
      </p>
    </div>

    <a routerLink="/enrollments/new"
      class="btn btn-primary">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      Nueva Inscripción
    </a>
  </div>

  <!-- ============================================================ -->
  <!-- KPIs (7 métricas — mismo desglose de producción)             -->
  <!-- ============================================================ -->
  <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3">

    <div class="kpi-card kpi-sky">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
          </svg>
        </span>
        Total
      </div>
      <div class="kpi-value">{{ totalRecords }}</div>
    </div>

    <div class="kpi-card kpi-amber">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        Pendientes
      </div>
      <div class="kpi-value">{{ pendingEnrollments }}</div>
    </div>

    <div class="kpi-card kpi-emerald">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        Activas
      </div>
      <div class="kpi-value">{{ activeEnrollments }}</div>
    </div>

    <div class="kpi-card kpi-rose">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </span>
        Retiradas
      </div>
      <div class="kpi-value">{{ withdrawnEnrollments }}</div>
    </div>

    <div class="kpi-card kpi-orange">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        Aplazadas
      </div>
      <div class="kpi-value">{{ deferredEnrollments }}</div>
    </div>

    <div class="kpi-card kpi-slate">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5" />
          </svg>
        </span>
        Proyectos
      </div>
      <div class="kpi-value">{{ activeProjects }}</div>
    </div>

    <div class="kpi-card kpi-violet">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>
        Nuevas · 7d
      </div>
      <div class="kpi-value">{{ recentEnrollments }}</div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Toolbar de filtros                                            -->
  <!-- ============================================================ -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <!-- Buscar -->
      <div class="col-span-12 md:col-span-4">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none"
            stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onFilterChange()"
            [placeholder]="view === 'individual' ? 'Buscar por documento, nombre o email...' : 'Buscar por NIT, empresa o proyecto...'"
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <!-- ID -->
      <div class="col-span-6 md:col-span-2">
        <input type="number" [(ngModel)]="filterId" (ngModelChange)="onFilterChange()" placeholder="ID #"
          class="w-full px-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400 tabular-nums">
      </div>

      <!-- Estado -->
      <div class="col-span-6 md:col-span-2">
        <p-dropdown [options]="[
            {label: 'Todos los estados', value: ''},
            {label: 'Pendiente', value: '0'},
            {label: 'Activa', value: '1'},
            {label: 'Completada', value: '4'},
            {label: 'Retirada', value: '2'},
            {label: 'Aplazada', value: '3'},
            {label: 'Refinanciada', value: '5'},
            {label: 'Reversada', value: '6'},
            {label: 'Reintegro', value: '7'}
          ]" [(ngModel)]="selectedStatus" (onChange)="onFilterChange()" styleClass="w-full" placeholder="Estado"
          optionLabel="label" optionValue="value" [showClear]="true" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <!-- Proyecto -->
      <div class="col-span-12 md:col-span-2">
        <p-dropdown [options]="uniqueProjects" [(ngModel)]="selectedProject" (onChange)="onFilterChange()"
          styleClass="w-full" placeholder="Proyecto" optionLabel="name" optionValue="id" [showClear]="true"
          [filter]="true" filterBy="projectId,name" appendTo="body" panelStyleClass="filter-dropdown-panel"
          [style]="{'width':'100%'}">
          <ng-template let-project pTemplate="selectedItem">
            <div class="flex items-center gap-2" *ngIf="project">
              <span class="font-mono text-xs font-semibold text-blue-600">{{ project.projectId }}</span>
              <span class="truncate">{{ project.name }}</span>
            </div>
          </ng-template>
          <ng-template let-project pTemplate="item">
            <div class="flex items-center gap-2">
              <span class="font-mono text-xs font-semibold text-blue-600">{{ project.projectId }}</span>
              <span>{{ project.name }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Alertas (filtro de inconsistencias renombrado) -->
      <div class="col-span-12 md:col-span-2">
        <p-dropdown [options]="[
            {label: 'Sin alertas', value: ''},
            {label: 'Cuotas PENDING con pagos', value: 'pending_with_payments'},
            {label: 'Necesita atención (total ≠ cuotas)', value: 'needs_attention'}
          ]" [(ngModel)]="inconsistencyFilter" (onChange)="onInconsistencyFilterChange()" styleClass="w-full"
          placeholder="Alertas" optionLabel="label" optionValue="value" [showClear]="true"
          appendTo="body" panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>
    </div>

    <!-- Botón corregir inconsistencias (cuando aplica) -->
    <div *ngIf="inconsistencyFilter === 'pending_with_payments' && filteredData.length > 0" class="mt-3 flex justify-end">
      <button (click)="fixInconsistencies()" [disabled]="isFixingInconsistencies" class="btn btn-warning btn-sm">
        <svg *ngIf="!isFixingInconsistencies" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17l-5.25-2.63a2 2 0 010-3.58L11.42 6.33a2 2 0 011.16 0l5.25 2.63a2 2 0 010 3.58l-5.25 2.63a2 2 0 01-1.16 0z" />
        </svg>
        <svg *ngIf="isFixingInconsistencies" class="animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
        {{ isFixingInconsistencies ? 'Corrigiendo…' : 'Corregir inconsistencias' }}
      </button>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Tabla                                                         -->
  <!-- ============================================================ -->
  <div class="rounded-xl border border-slate-200 bg-white overflow-x-auto">
    <table class="enrollment-table">
      <thead>
        <tr>
          <th class="sortable" (click)="onSortChange('id')">
            <div class="inline-flex items-center gap-1">
              ID
              <svg *ngIf="sortBy === 'id'" class="w-3 h-3 transition-transform"
                [class.rotate-180]="sortDirection === 'asc'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
              <svg *ngIf="sortBy !== 'id'" class="w-3 h-3 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
              </svg>
            </div>
          </th>
          <th>Documento</th>
          <th>{{ view === 'individual' ? 'Participante' : 'Empresa' }}</th>
          <th>Proyecto</th>
          <th>Creación</th>
          <th>Estado</th>
          <th>Auditoría</th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of filteredData">

          <!-- ID -->
          <td class="tabular-nums font-medium text-slate-700">
            #{{ data.id }}
          </td>

          <!-- Vista Individual -->
          <ng-container *ngIf="view === 'individual'">

            <!-- Documento -->
            <td>
              <div class="doc-cell">
                <span class="doc-type">{{ data.participant.typeDocument }}</span>
                <span class="doc-number">{{ data.participant.documentId }}</span>
              </div>
            </td>

            <!-- Participante -->
            <td>
              <a [routerLink]="['/dashboard/enrollments/view-v2', data.id]" target="_blank" class="participant-cell group">
                <div class="initials-avatar"
                  [ngClass]="'tone-' + getInitialsTone(data.participant.firstName)">
                  {{ getInitials(data.participant.firstName, data.participant.lastName) }}
                </div>
                <div class="participant-meta">
                  <div class="participant-name">
                    {{ data.participant.firstName }} {{ data.participant.lastName }}
                    <svg class="external-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </div>
                  <div class="participant-email">{{ data.participant.email }}</div>
                </div>
              </a>
            </td>
          </ng-container>

          <!-- Vista Empresarial -->
          <ng-container *ngIf="view === 'corporate'">

            <!-- Documento (NIT) -->
            <td>
              <div class="doc-cell">
                <span class="doc-type">NIT</span>
                <span class="doc-number">{{ data.company?.documentId || 'N/A' }}</span>
              </div>
            </td>

            <!-- Empresa -->
            <td>
              <a [routerLink]="['/dashboard/enrollments/corporate/view-v2', data.corporateEnrollmentAgreementId]"
                target="_blank" class="participant-cell group">
                <div class="initials-avatar"
                  [ngClass]="'tone-' + getInitialsTone(data.company?.name)">
                  {{ getCompanyInitials(data.company?.name) }}
                </div>
                <div class="participant-meta">
                  <div class="participant-name">
                    {{ data.company?.name || 'Sin nombre' }}
                    <svg class="external-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </div>
                  <div class="participant-email">
                    {{ data.company?.email || 'Sin email' }} · <span class="tabular-nums text-blue-600 font-medium">{{ data.participantsCount }} participante(s)</span>
                  </div>
                </div>
              </a>
            </td>
          </ng-container>

          <!-- Proyecto -->
          <td>
            <div class="project-chip">
              <span class="project-code">{{ data.project.projectId }}</span>
              <span class="project-name" [title]="data.project.name">{{ data.project.name }}</span>
            </div>
          </td>

          <!-- Fecha creación -->
          <td class="text-slate-500 tabular-nums">
            {{ data.createdAt | date:'dd/MM/yy' }}
          </td>

          <!-- Estado + alertas -->
          <td>
            <div class="flex flex-wrap items-center gap-1.5">
              <span class="pill"
                [ngClass]="{
                  'pill-amber':  data.status === 0 || data.status === 'Pending',
                  'pill-emerald': data.status === 1 || data.status === 'Active' || data.status === 4 || data.status === 'Completed',
                  'pill-rose':   data.status === 2 || data.status === 'Withdrawn' || data.status === 6 || data.status === 'Reversed',
                  'pill-violet': data.status === 3 || data.status === 'Deferred',
                  'pill-sky':    data.status === 5 || data.status === 'Refinanced' || data.status === 7 || data.status === 'Refund',
                  'pill-teal':   data.status === 8 || data.status === 'SlotTransfer',
                  'pill-neutral':data.status === undefined || data.status === null
                }">
                {{ getEnrollmentStatusLabel(data.status) }}
              </span>
              <span *ngIf="isWithdrawnOrDeferred(data.status)" class="pill pill-rose"
                title="Cartera castigada">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <span *ngIf="data.needsAttention" class="pill pill-amber"
                [title]="data.needsAttentionReason || 'El total de la inscripción no coincide con la suma de cuotas activas'">
                <i class="fas fa-exclamation-circle"></i> Atención
              </span>
            </div>
          </td>

          <!-- Auditoría (compacta) -->
          <td>
            <app-audit-info [auditData]="{
              createdBy: data.createdBy,
              createdAt: data.createdAt,
              updatedBy: data.updatedBy,
              updatedAt: data.updatedAt,
              deletedBy: data.deletedBy,
              deletedAt: data.deletedAt,
              isDeleted: data.isDeleted
            }" layout="compact" size="sm">
            </app-audit-info>
          </td>

          <!-- Acciones -->
          <td class="text-right">
            <a *ngIf="view === 'individual'" [routerLink]="['/dashboard/enrollments/view-v2', data.id]"
              class="row-action row-action--primary" title="Ver inscripción">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
              <span>Ver</span>
            </a>
            <a *ngIf="view === 'corporate'"
              [routerLink]="['/dashboard/enrollments/corporate/view-v2', data.corporateEnrollmentAgreementId]"
              class="row-action row-action--primary" title="Ver inscripción empresarial">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
              <span>Ver</span>
            </a>
          </td>
        </tr>

        <!-- Empty state -->
        <tr *ngIf="filteredData.length === 0">
          <td colspan="8" class="text-center py-10">
            <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
              <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0z" />
              </svg>
            </div>
            <p class="text-sm font-medium text-slate-700">No se encontraron inscripciones</p>
            <p class="text-xs text-slate-500 mt-1">Ajustá los filtros o crea una nueva inscripción.</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginador -->
  <div class="bg-white rounded-xl border border-slate-200">
    <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 50, 100]"
      (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords}">
    </p-paginator>
  </div>

</div>
